const TOKYO_TIME_ZONE = "Asia/Tokyo";
const DRIVER_CHAT_COMPLETION_DELAY_MS = 24 * 60 * 60 * 1000;

function tokyoParts(date = new Date()) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: TOKYO_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const parts = Object.fromEntries(formatter.formatToParts(date).map((part) => [part.type, part.value]));
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
  };
}

function dateKeyFromParts({ year, month, day }) {
  return [
    String(year).padStart(4, "0"),
    String(month).padStart(2, "0"),
    String(day).padStart(2, "0"),
  ].join("-");
}

export function getTokyoDateKey(date = new Date()) {
  return dateKeyFromParts(tokyoParts(date));
}

export function addDaysToDateKey(dateKey, days) {
  const match = String(dateKey || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return getTokyoDateKey();
  const [, year, month, day] = match;
  const utcDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day) + Number(days || 0)));
  return dateKeyFromParts({
    year: utcDate.getUTCFullYear(),
    month: utcDate.getUTCMonth() + 1,
    day: utcDate.getUTCDate(),
  });
}

export function getTokyoMonthRange(date = new Date()) {
  const { year, month } = tokyoParts(date);
  const start = dateKeyFromParts({ year, month, day: 1 });
  const endDate = new Date(Date.UTC(year, month, 0));
  const end = dateKeyFromParts({
    year: endDate.getUTCFullYear(),
    month: endDate.getUTCMonth() + 1,
    day: endDate.getUTCDate(),
  });
  return { start, end };
}

export function isDriverChatCompletedByOrderTime(order, now = new Date()) {
  const date = String(order?.departure_date || "").trim();
  const time = String(order?.pickup_time || "").trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/.test(time)) {
    return false;
  }
  const startAt = Date.parse(`${date}T${time.length === 5 ? `${time}:00` : time}+09:00`);
  const nowAt = now instanceof Date ? now.getTime() : new Date(now).getTime();
  return Number.isFinite(startAt) && Number.isFinite(nowAt) && nowAt >= startAt + DRIVER_CHAT_COMPLETION_DELAY_MS;
}
